import { render, staticRenderFns } from "./ClaimSection.vue?vue&type=template&id=be493218&"
import script from "./ClaimSection.vue?vue&type=script&lang=js&"
export * from "./ClaimSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports